import { render } from "./ItemForm.vue?vue&type=template&id=126c23a6&scoped=true&ts=true"
import script from "./ItemForm.vue?vue&type=script&lang=ts"
export * from "./ItemForm.vue?vue&type=script&lang=ts"

import "./ItemForm.vue?vue&type=style&index=0&id=126c23a6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src93515913/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126c23a6"]])

export default __exports__